import { Component, HostBinding, Signal } from '@angular/core';
import {
  Agent,
  AgentKeys,
  ChangeSourceType,
  CONFERENCE_REGISTRATIONS_TASKS_STATUS_LOOKUP,
  ConferenceKeys,
  ConferenceRegistrationCommonTaskStatus,
  Entity,
  EntityPermissionActivityKeys,
  Excursion,
  Role,
} from 'ag-common-lib/public-api';
import { ExcursionInfoTableData } from 'ag-common-svc/lib/components/excursions-info-table/excursions-info-table.models';
import { AttendeeExcursionsService } from './attendee-excursions.service';
import {
  AssignedOwnerDetails,
  AssignedOwnerDetailsKeys,
} from 'ag-common-svc/lib/components/ag-assign-owner-viewer/config/ag-assign-owner.config';
import { ValueChangedEvent } from 'devextreme/ui/select_box';
import { AttendeeDetailsModalService } from '../attendee-details-modal.service';

@Component({
  selector: 'ag-crm-attendee-excursions',
  templateUrl: './attendee-excursions.component.html',
  styleUrls: ['./attendee-excursions.component.scss'],
  providers: [AttendeeExcursionsService],
})
export class AttendeeExcursionsComponent {
  @HostBinding('class') className = 'attendee-excursions';

  protected mainEventExcursionsBudgetSig: Signal<number> = this.attendeeExcursionsService.mainEventExcursionsBudgetSig;
  protected mainEventExcursionsSig: Signal<Excursion[]> = this.attendeeExcursionsService.mainEventExcursionsSig;
  protected mainEventSelectedExcursionsDataSourceSig: Signal<ExcursionInfoTableData[]> =
    this.attendeeExcursionsService.mainEventSelectedExcursionsDataSourceSig;
  protected chairmanExtExcursionsBudgetSig: Signal<number> =
    this.attendeeExcursionsService.chairmanExtExcursionsBudgetSig;
  protected chairmanExtExcursionsSig: Signal<Excursion[]> = this.attendeeExcursionsService.chairmanExtExcursionsSig;
  protected chairmanExtSelectedExcursionsDataSourceSig: Signal<ExcursionInfoTableData[]> =
    this.attendeeExcursionsService.chairmanExtSelectedExcursionsDataSourceSig;
  protected excursionStatisticsMapSig = this.attendeeExcursionsService.excursionStatisticsMapSig;
  protected excursionsTaskStatus$ = this.attendeeExcursionsService.excursionsTaskStatus$;
  protected isAcceptedChairmanExtensionSig = this.attendeeDetailsModalService.isAcceptedChairmanExtensionSig;
  protected assignOwnerList$ = this.attendeeExcursionsService.assignOwnerList$;
  protected readonly taskStatus = CONFERENCE_REGISTRATIONS_TASKS_STATUS_LOOKUP;
  protected readonly Entity = Entity;
  protected readonly EntityPermissionActivityKeys = EntityPermissionActivityKeys;
  protected readonly sourceType = ChangeSourceType.regularArm;
  protected readonly ConferenceKeys = ConferenceKeys;
  protected readonly CHAIRMAN_EXT_REGISTRANT_SELECTED_EXCURSIONS_KEY =
    this.attendeeExcursionsService.CHAIRMAN_EXT_REGISTRANT_SELECTED_EXCURSIONS_KEY;
  protected readonly CHAIRMAN_EXT_GUEST_SELECTED_EXCURSIONS_KEY =
    this.attendeeExcursionsService.CHAIRMAN_EXT_GUEST_SELECTED_EXCURSIONS_KEY;

  constructor(
    private attendeeExcursionsService: AttendeeExcursionsService,
    private attendeeDetailsModalService: AttendeeDetailsModalService,
  ) {}

  protected onOwnerChange = (data: AssignedOwnerDetails) => {
    return this.attendeeExcursionsService.updateExcursionsTask({
      assignedTo: data?.[AssignedOwnerDetailsKeys.assignedTo] ?? null,
      assignedPersonNote: data?.[AssignedOwnerDetailsKeys.assignedToNote] ?? null,
    });
  };

  protected onTaskStatusChanged = (flyTaskStatus: ConferenceRegistrationCommonTaskStatus, e: ValueChangedEvent) => {
    if (flyTaskStatus === e?.value) {
      return;
    }

    this.attendeeExcursionsService.updateExcursionsTask({
      status: e?.value ?? null,
    });
  };
}
